import organizationApiFetch from "./organizationApiFetch";

const CUSTOMER_PORTAL_API_URL = process.env.REACT_APP_STORE_SERVER_URL || "http://localhost:8085";
const CALENDAR_SERVICE_URL = process.env.REACT_APP_CALENDAR_SERVICE_URL || "http://localhost:8087";

export async function requestLoginCodeByPhone(phone) {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/request-code`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: { phone },
  });

  let payload = {}

  try {
    payload = await response.json()
  }
  catch {
    payload = {}
  }

  if (!response.ok) {
    throw new Error(payload.error || "Customer portal request failed")
  }

  return payload
}

export async function verifyOTPLoginCode(phone, code) {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/verify-code`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: { phone, code },
  });

  let payload = {}

  try {
    payload = await response.json()
  }
  catch {
    payload = {}
  }

  if (!response.ok) {
    throw new Error(payload.error || "Code verification failed")
  }

  return payload
}

export async function getCustomerPortalSession() {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/session`, {
    method: "GET",
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    return { authenticated: false, customer_id: null };
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to verify customer session");
  }

  return payload;
}

export async function fetchCustomerInfo() {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/info`, {
    method: "GET",
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    return { authenticated: false, customer_id: null };
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to fetch customer info");
  }

  return payload;
}

export async function fetchCustomerAppointments(customerId) {
  const response = await organizationApiFetch(`${CALENDAR_SERVICE_URL}/calendar/appointments/customer/${customerId}`, {
    method: "GET",
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    return [];
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to fetch customer appointments");
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.appointments)) {
    return payload.appointments;
  }

  return [];
}

export async function cancelCustomerAppointment(appointmentId) {
  const response = await organizationApiFetch(`${CALENDAR_SERVICE_URL}/calendar/appointments/customer/cancel/${appointmentId}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to cancel appointment");
  }

  return payload;
}

export async function createCustomerPortalSetupIntent() {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/setup-intent`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    throw new Error("not authenticated");
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to create payment setup intent");
  }

  return payload;
}

export async function updateCustomerPaymentMethod(setupIntentId) {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/payment-method`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: { setup_intent_id: setupIntentId },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    throw new Error("not authenticated");
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to update payment method");
  }

  return payload;
}

export async function removeCustomerPaymentMethod() {
  const response = await organizationApiFetch(`${CUSTOMER_PORTAL_API_URL}/service/customer-portal/payment-method`, {
    method: "DELETE",
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (response.status === 401) {
    throw new Error("not authenticated");
  }

  if (!response.ok) {
    throw new Error(payload.error || "Unable to remove payment method");
  }

  return payload;
}
